import {List, Record} from 'immutable';
import i18next from 'i18next';
import {type BadgeProps} from 'modern-famly';

import {type TabOwnProps} from 'web-app/react/components/tabs/tabs';
import {type Employee} from 'web-app/react/entities/employees/model';

export type Tab = TabOwnProps;

export interface TabFromApi {
    id: string;
    title: string;
    groupsCount: number; // How many groups are in the tab
    tagCount: number; // How many tags are in the tab
    count: number; // How many children are checked in
}

const formatTabTitle = (title: TabFromApi['title']) => {
    switch (title) {
        case 'GROUPS':
            return i18next.t('overview.tab_GROUPS');
        case 'STAR':
            return i18next.t('overview.tab_STAR');
        case 'TAGS':
            return i18next.t('overview.tab_TAGS');
        default:
            // In this case we have a department tab
            return title;
    }
};

const formatTabBadge = (tab: TabFromApi): BadgeProps | undefined => {
    switch (tab.id) {
        case 'STAR':
        case 'TAGS':
            return undefined;
        default:
            return {
                badgeContent: tab.count,
                severity: 'success',
            };
    }
};

export const convertTabFromApi = (tab: TabFromApi): Tab => ({
    id: tab.id,
    title: formatTabTitle(tab.title),
    selected: false,
    badgeProps: formatTabBadge(tab),
});

export interface Department {
    departmentId: string;
    title: string;
}

// Opening hours
export interface BaseOpeningHour {
    day: number;
    fromHour: number;
    fromMinute: number;
    open: boolean;
    toHour: number;
    toMinute: number;
}
export class OpeningHour extends Record<BaseOpeningHour>({
    day: 0,
    fromHour: 0,
    fromMinute: 0,
    open: false,
    toHour: 0,
    toMinute: 0,
}) {}
export const openingHourFromApi = (openingHour: BaseOpeningHour) => new OpeningHour(openingHour);

export interface StatusConfigReduction {
    id: string;
    children?: number;
    employees?: number;
    color: string;
    icon: string;
    title: string;
}

export class Birthdays extends Record<{
    children: List<any>; // Child entity
    employees: List<Employee>;
}>({
    children: List(),
    employees: List(),
}) {}

export enum PersonType {
    Child = 'child',
    Employee = 'employee',
}
